interface FindIdFormProps {
  name: string;
  phone: string;
  isLoading: boolean;
  onNameChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onSubmit: () => void;
  className?: string;
}

export function FindIdForm({ 
  name, 
  phone, 
  isLoading,
  onNameChange, 
  onPhoneChange, 
  onSubmit,
  className = '' 
}: FindIdFormProps) {
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className={`space-y-6 ${className}`}>
      {/* 설명 텍스트 */}
      <div className="text-center mb-8">
        <p className="text-[16px] text-gray-600">
          가입 시 입력한 이름과 전화번호를 입력해주세요
        </p>
      </div>

      {/* 이름 입력 */}
      <div>
        <label className="block text-[16px] font-medium text-[#222222] mb-3">
          이름
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="이름을 입력해주세요"
          className="w-full h-[50px] px-4 text-[16px] border-[1.5px] border-[#DEDEDE] rounded-xl focus:outline-none focus:border-[#51C854] placeholder:text-[#999999]"
        />
      </div>

      {/* 전화번호 입력 */}
      <div>
        <label className="block text-[16px] font-medium text-[#222222] mb-3">
          전화번호
        </label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          placeholder="01012345678"
          className="w-full h-[50px] px-4 text-[16px] border-[1.5px] border-[#DEDEDE] rounded-xl focus:outline-none focus:border-[#51C854] placeholder:text-[#999999]"
        />
      </div>

      {/* 찾기 버튼 */}
      <button
        type="submit"
        disabled={isLoading || !name.trim() || !phone.trim()}
        className="w-full h-[50px] bg-[#51C854] text-white font-semibold text-[16px] rounded-xl hover:bg-[#46B649] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
      >
        {isLoading ? '찾는 중...' : '아이디 찾기'}
      </button>
    </form>
  );
}